import React, { FunctionComponent, useEffect, useState } from "react"
import Image from "next/image"
import Box from "@mui/material/Box"
import LinearProgress from "@mui/material/LinearProgress"
import useDevice from "hooks/useDevice"

const ThankYouBanner: FunctionComponent<{
  title: string
  postAction?: () => void
  totalTime?: number
}> = ({ title, postAction, totalTime }) => {
  const totalTimeToUse = totalTime || 3000
  const [progressBar, setProgressBar] = useState(totalTimeToUse)
  const [hideBanner, setHideBanner] = useState(false)
  const { isMobile } = useDevice()

  const getPerOfProgress = (value: number) => {
    return (value / totalTimeToUse) * 100
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setProgressBar((prevProgress) => {
        if (prevProgress > 0) {
          return prevProgress - 300
        } else {
          clearInterval(timer)
          setHideBanner(true)
          if (postAction) {
            postAction()
          }
          return 0
        }
      })
    }, 300)
    return () => {
      clearInterval(timer)
    }
  }, [])

  return !hideBanner ? (
    <div className="border border-[#F5F5F7] bg-white">
      <div className="flex justify-center items-center px-4 pt-2 rounded-[8px] mt-2 mb-3 w-full">
        <div className="flex justify-center items-center gap-2 w-full">
          <Image
            src={`${process.env.CDN_URL}/assets/icons/check_circle_fill.svg`}
            height={isMobile ? 20 : 27}
            width={isMobile ? 20 : 27}
            alt="tick"
          />
          <div className="text-[#0D6008] text-[12px] md:text-[16px]">
            {title}
          </div>
        </div>
      </div>
      <Box sx={{ width: "100%" }}>
        <LinearProgress
          variant="determinate"
          color="inherit"
          sx={{
            color: "#44AC21",
            height: "2px",
          }}
          value={getPerOfProgress(progressBar)}
        />
      </Box>
    </div>
  ) : (
    <div className="h-[52px] md:h-[59px]" />
  )
}

export default ThankYouBanner
